import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'post'
})
export class PostPipe implements PipeTransform {

  transform(value: [], page: number = 0): unknown {
    if(!value){
      return null;
    }

    return value.slice(page, page +5);
  }

}
